export enum SearchItemTypes {
  PROJECT = 'Project',
  PROCUREMENT = 'Procurement',
  COMPANY = 'Company',
}